import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppServiceService } from 'src/app/api/app-service.service';

declare var config: any;


@Component({
  selector: 'app-restaurant-review',
  templateUrl: './restaurant-review.page.html',
  styleUrls: ['./restaurant-review.page.scss'],
})
export class RestaurantReviewPage implements OnInit {

  slug: any;

  constructor(private route: ActivatedRoute,private rou: Router,public appService:AppServiceService,private sanitize: DomSanitizer) {

    this.route.params.subscribe((param) => {
      this.slug = param.slug;
    });


  }


  ngOnInit() {
  }

  ionViewDidEnter() {

    this.appService.getRestaurantBySlug(this.slug);

  }

  ionViewWillEnter() {
  }

  getMapURL(restaurant){
    return this.sanitize.bypassSecurityTrustResourceUrl('https://www.google.com/maps/embed/v1/place?q='+restaurant.latitude+','+restaurant.longitude+'&key='+config.gkey);

  }

  showMap(address){
    // var url = "https://maps.google.com/?q=" + lat + "," + lng;
    // window.open(url);

    if(address) window.location.href = "https://maps.google.com/?q=" + address;
  }

  orderPro(slug) {
    this.appService.getRestaurantBySlug(slug);
    this.rou.navigate(['delivery-method'], {
      queryParams: {
        isOrderProcess: true
      }
    });
  }

}
